import React from "react"
import styled from "styled-components"

const StyledListContent = styled.p`
  margin-block-start: 0.2rem;
  line-height: 1.5;
`

export default function ListContent({ content, content2 = null }) {
  if (content2) {
    return (
      <StyledListContent>
        {content}
        <br />
        {content2}
      </StyledListContent>
    )
  }
  return <StyledListContent>{content}</StyledListContent>
}
